<template>
	<section class="pt-300 pb-400">
		<div class="container">
			<div
				class="vcx-featured position-relative display-flex align-items-center justify-content-center overflow-hidden"
			>
				<img
					:src="`${appCloudfrontPath}/images/vcx/vcx-hero.webp`"
					alt=""
					class="vcx-featured__bg-image"
					aria-hidden="true"
				/>
				<div
					class="position-relative display-flex flex-direction-column align-items-center gap-225 py-250 px-150 py-350-md px-400-md"
				>
					<div class="display-flex flex-direction-column align-items-center gap-150">
						<BaseSvgIcon
							name="fundrise-vcx-logo-stacked"
							width="111px"
							height="51px"
							title="VCX by Fundrise"
						/>
						<h2 class="heading-1 text-color-white text-align-center">
							VCX is now trading on the&nbsp;NYSE
						</h2>
						<p class="body-lg text-color-white text-align-center col-7-md mt-0">
							VCX is a public venture fund that gives you access to top private tech companies, from AI to
							space exploration, in a single&nbsp;investment.
						</p>
					</div>
					<BaseLink :link="learnMoreLink" classes="button button-vcx" />
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import BaseLink from '@components/_base-link.vue';
import BaseSvgIcon from '@components/_base-svg-icon.vue';
import { type Link } from 'types/layout';

const learnMoreLink: Link = {
	text: 'Learn more about VCX',
	router: 'vcx-landing'
};
</script>

<style scoped lang="scss">
@use '../../styles/constants/colors' as *;

.vcx-featured {
	border-radius: 16px;
	background-color: token('content-primary');

	:deep(.button-vcx) {
		background-color: orange(40);
		border-color: orange(40);
		color: token('content-primary');

		&:hover {
			background-color: rgba(orange(40), 0.75);
			border-color: rgba(orange(40), 0.75);
		}
	}

	&__bg-image {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center bottom;
		opacity: 0.8;
	}
}
</style>
